<div class="page-title">DASHBOARD</div>

<div style="padding: 10px;"></div>

<div class="flex-container">
  @if (this.hasPermissionsPNC) {
    <div class="card-spacer">
      <div class="model-content-dashboard">
        <div class="modal-header">
          <p class="modal-title">PNCs</p>
        </div>
        @if (!pncDashboardReady) {
          <app-loading-spinner style="min-height: 160px;"></app-loading-spinner>
        }
        <app-dashboard-error [hasError]="hasErrorPNC" [canReload]="false"></app-dashboard-error>
        @if (!hasErrorPNC) {
          <div class="modal-body">
            @if (pncDashboardReady) {
              <div class="modal-text" style="min-height: 160px;">
                @for (tuple of PNCs; track tuple) {
                  <div class="key-value">
                    <span>{{ tuple.key }}</span>
                    <span>{{ tuple.value }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        <div class="modal-footer">
          <button class="btn-primary" (click)="navigate('pnc')">View PNCs</button>
        </div>
      </div>
    </div>
  }

  @if (this.hasPermissionsSPO) {
    <div class="card-spacer">
      <div class="modal-content model-content-dashboard">
        <div class="modal-header">
          <p class="modal-title">SPOs</p>
        </div>
        @if (!spoDashboardReady) {
          <app-loading-spinner style="min-height: 160px;"></app-loading-spinner>
        }
        <app-dashboard-error [hasError]="hasErrorSPO" [canReload]="false"></app-dashboard-error>
        @if (!hasErrorSPO) {
          <div class="modal-body">
            @if (spoDashboardReady) {
              <div class="modal-text" style="min-height: 160px;">
                @for (tuple of SPOs; track tuple) {
                  <div class="key-value">
                    <span>{{ tuple.key }}</span>
                    <span>{{ tuple.value }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        <div class="modal-footer">
          <button class="btn-primary" (click)="navigate('spo')">View SPOs</button>
        </div>
      </div>
    </div>
  }
</div>

@if (!claimsDashboardReady) {
  <app-loading-spinner></app-loading-spinner>
}
<app-dashboard-error [hasError]="hasError" [canReload]="false"></app-dashboard-error>

<div class="flex-container">
  @for (tuple of partnersCurrent; track tuple) {
    <div>
      <app-dashboard-card
        [partnerCode]="tuple.key"
        [partnerName]="tuple.value"
        (claimReady)="getNext()">
      </app-dashboard-card>
    </div>
  }
  @if (counterDisplayedTiles < partnersTotal.length) {
    <div class="model-content-dashboard-placeholder">
      <div class="modal-header-placeholder"><p class="modal-title dot-dot-dot"></p></div>
      <app-loading-spinner style="min-height: 270px; position:relative;"></app-loading-spinner>
    </div>
  }
</div>
